import React from 'react'

const RatingsBadge = ({rating}) => {
  return (
    <div className={`rating-badge rounded-4`}>
        {rating.label}
    </div>
  )
}
   
export default RatingsBadge